package net.dipgo.gamerooms

import net.dipgo.game.MoveResult
import net.dipgo.game.PointState
import net.dipgo.game.TeamScore
import net.dipgo.game.board.BoardPosition
import net.dipgo.game.demo.DemoBoardMove

data class DemoBoardSituation(
    val boardPosition: BoardPosition,
    val playerToMove: Int,
    val scores: Map<Int, TeamScore>,
    val remainingTeams: List<PointState>,
    val lastMove: DemoBoardMove?,
    val movestring: String,
    val moveResult: MoveResult = MoveResult.SUCCESS,
    val captures: Boolean,
) {
    val board: Array<Array<PointState>> = boardPosition.getStateOfBoard()
    val numberOfMoves: Int = movestring.length / 2
    fun gameIsOver() = playerToMove == 0

    companion object {
        /**
         * Cuts a movestring at the point the game irrecoverably ends: when all but one team
         * has resigned. A run of passes is deliberately NOT an end any more — an all-pass
         * pauses the game for the dead-stone scoring phase, from which play may legally
         * resume, so moves after it are resumed play and must be kept.
         */
        fun truncateMovestring(originalMovestring: String, numberOfTeams: Int): String {
            require(originalMovestring.length % 2 == 0)

            var numberOfResignations = 0

            val moves = mutableListOf<String>()
            for (i in originalMovestring.indices step 2) {
                val thisMove = originalMovestring.substring(i, i + 2)
                moves.add(thisMove)

                if (thisMove == "00") {
                    numberOfResignations++
                    if (numberOfResignations >= numberOfTeams - 1) {
                        break
                    }
                }
            }

            return moves.joinToString("")
        }
    }
}
